import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
type Props = {
  title?: string;
  image?: string;
  description?: string;
  keywords?: string[];
};

const Head: React.FC<Props> = (p) => {
  const title = p.title ? `${p.title} | DuoCards` : null;
  const { t } = useTranslation();

  const description = p.description
    ? p.description
    : t(
        "Boost your vocabulary with a language flashcard learning app. Learn English, Spanish, French or any other language."
      );

  const defaultKeywords = ["flashcards", "learn", "vocabulary"].map((k) => t(k));

  const keywords = [...(p.keywords || []), ...defaultKeywords, "DuoCards"].join(",");

  return (
    <Helmet>
      <meta property="keywords" content={keywords.substring(0, 155) + (keywords.length > 156 ? "..." : "")} />

      {title && <title>{title}</title>}

      <meta property="description" content={description.substring(0, 155) + (description.length > 156 ? "..." : "")} />

      {/* OPEN-GRAPH
      doesn't work atm, but maybe in future, or with usage of some SSR it will be */}
      {title && <meta property="og:title" content={title}></meta>}
      {p.image && <meta property="og:image" content={p.image}></meta>}
      {/* OPEN-GRAPH-END  */}
    </Helmet>
  );
};

export default Head;
